import $ from 'jquery';
import h from 'hyperscript';
import subMenuIcon from '@disy/cadenza-icons/submenu-arrow.svg';

import { Flyout } from 'ui/dialog/flyout/flyout';
import { LegacyMenu } from 'ui/legacy-menu/legacy-menu';

import { Action } from 'cadenza/action';
import { icon } from 'cadenza/utils/icon/icon';

import './flyout-menu.css';

let openedMenu;
let openedMenuTarget;
let copiedMenuTargets = [];
let openedSubMenu;
let openedSubMenuTarget;

/* eslint-disable -- because it's deprecated */

/**
 * A legacy menu
 *
 * @deprecated - Use `setupMenuButton()` instead.
 */
export function openMenu (event, content, {
  target, /* Optional target. If available use this for menu positioning,
           otherwise eventAsTarget behaviour will be used for menu positioning
           */
  eventAsTarget = false, /* Default value false means:
                         Use (event.currentTarget or event.target) instead of the event itself
                         as target for the flyout to open
                         */
  displayArrow = true, // Default value true means: Show the arrow of the menu
  styleClass, // Additional style class added to the dialogs of the flyouts of the menu and submenus.
  position, // Position as {at, my, collision, offset}
  openDelay, // Delay to open the current menu
  openNewMenuCheck, // Optional function to check whether menu has to be opened or not.
  closeMenuEvents, // Optional string with space separated event types on which menu closes
  closeMenuCheck = (event) => true, // Optional function to check whether menu has to be closed or not.
  onClose = () => {}, // Additional onClose function. Executed before removing the menu-flyout.
  flyoutParent = document.body, // Optional: To what element should the flyout be appended
  offsetArrowPositioning // Allows to override arrow rotation calculations and positioning
} = {}, arrowLeftPositionFix = 5) { // Used to fix positioning of the arrow when present, default value is 5 px
  const menuTarget = target || (eventAsTarget ? event : (event.currentTarget || event.target));
  const openNewMenuCheckFunctionAvailable = openNewMenuCheck && (typeof openNewMenuCheck === 'function');
  const openNewMenu = openNewMenuCheckFunctionAvailable ? openNewMenuCheck() : true;
  let noTargetMenu = !menuTarget.$$menu;
  if (noTargetMenu && !openNewMenu && openedMenu) {
    menuTarget.$$menu = openedMenu;
    if (!copiedMenuTargets.includes(menuTarget)) {
      copiedMenuTargets.push(menuTarget);
    }
  }
  noTargetMenu = !menuTarget.$$menu;
  if ((noTargetMenu && openNewMenu) || (openNewMenuCheckFunctionAvailable && openNewMenu)) {
    if (openedMenu) {
      openedMenu.closeNow();
    }
    const menu = new LegacyMenu({
      openDelay,
      open () {
        if (typeof content === 'function') {
          content = content();
        }
        if (!Array.isArray(content)) {
          content = [ content ];
        }
        content = content.map(item => {
          if (item instanceof Action) {
            return createButton(item);
          }
          return item;
        });

        const flyout = new Flyout({ displayArrow });
        this._flyout = flyout;
        flyout.dialog.classList.add('d-flyout-menu', 'd-action-buttons', styleClass);
        flyout.dialog.append(...content);
        flyout.closeMenu = () => {
          menu.closeNow();
        }
        $(flyout).on('click', '.button:not(\'.button-sub-menu\')', () => {
          flyout.closeMenu();
        });
        _initializeSubMenus(flyout, menu, styleClass);

        flyoutParent.appendChild(flyout);
        flyout.show(menuTarget, position, arrowLeftPositionFix, offsetArrowPositioning);
        return flyout;
      },
      closeMenuEvents,
      closeMenuCheck,
      close () {
        openedMenu = undefined;
        copiedMenuTargets.forEach((copiedMenuTarget) => {
          copiedMenuTarget.$$menu = undefined;
        });
        copiedMenuTargets = [];
        openedMenuTarget.$$menu = undefined;
        onClose();
        if (this._flyout) {
          this._flyout.remove();
          menuTarget.$$menu = null;
        }
      }
    });
    menuTarget.$$menu = menu;
    openedMenuTarget = menuTarget;
    openedMenu = menu;
  }
  openedMenu.scheduleOpen(event);
  return openedMenu;
}

function createButton (item) {
  return h('button.button.button-borderless',
    {
      type: 'button',
      title: item.label,
      onclick: () => item.execute()
    },
    [
      item.icon,
      item.label
    ]);
}

function _initializeSubMenus (flyout, menu, styleClass) {
  $(flyout).on('pointermove touchstart', '.button-sub-menu, .button-action', (event) => {
    _openSubMenu(flyout, event.target, styleClass);
  });
  _hideSubMenuEntries(flyout.dialog);
  $(flyout.dialog).find('.button-sub-menu').append(icon(subMenuIcon));
}

function _closeUnusedSubMenus (flyout, target, styleClass) {
  const isNotSubMenuIcon = $(target).is('.button:not(svg)');
  if (isNotSubMenuIcon && openedSubMenuTarget !== target) {
    const flyoutParent = $(target).closest('.d-flyout-menu').parent();
    const alreadyOpenedFlyoutSelector = flyoutParent.has('d-flyout');
    if (alreadyOpenedFlyoutSelector.length > 0) {
      let flyoutToClose = flyoutParent.find('d-flyout').last()[0];
      while (flyoutToClose) {
        const parentMenuIsTarget = flyoutToClose.parentMenu && flyoutToClose.parentMenu.is(target);
        if (!parentMenuIsTarget) {
          flyoutToClose.close();
          openedSubMenuTarget = null;
          openedSubMenu = null;
          const previousFlyout = $(flyoutToClose).prev('d-flyout')[0];
          if ($(previousFlyout).find(target).length <= 0) {
            flyoutToClose = previousFlyout;
          } else {
            flyoutToClose = undefined;
          }
        } else {
          openedSubMenu = flyoutToClose;
          openedSubMenuTarget = target;
          flyoutToClose = undefined;
        }
      }
    }
  }
}

function _openSubMenu (flyout, target, styleClass) {
  const flyoutContentSource = target;
  const $flyoutContentSource = $(target);
  _closeUnusedSubMenus(flyout, target, styleClass);
  const subMenuIsNotOpened = (!openedSubMenu) || (openedSubMenu.parentMenu && !openedSubMenu.parentMenu.is(flyoutContentSource));
  if (subMenuIsNotOpened && $flyoutContentSource.is('.button-sub-menu')) {
    const subMenuFlyout = new Flyout({ displayArrow: false });
    subMenuFlyout.dialog.classList.add('d-flyout-sub-menu', 'd-action-buttons', styleClass);
    const childrenToAdd = $flyoutContentSource.data('getChildren') || $flyoutContentSource.children('button');
    if (childrenToAdd.length > 0) {
      childrenToAdd.removeClass('closed');
      subMenuFlyout.dialog.append(...childrenToAdd.get());
      subMenuFlyout.parentMenu = $flyoutContentSource;
      subMenuFlyout.parentMenu.addClass('active');
      $(subMenuFlyout).on('close', () => {
        childrenToAdd.not('svg').addClass('closed');
        subMenuFlyout.parentMenu.append(...childrenToAdd.get());
        subMenuFlyout.parentMenu.removeClass('active');
        subMenuFlyout.remove();
      });
      _hideSubMenuEntries(subMenuFlyout.dialog);
      flyout.appendChild(subMenuFlyout);
      openedSubMenu = subMenuFlyout;
      openedSubMenu.show(flyoutContentSource, { at: 'right top', my: 'left top', offset: { top: -10 } });
      openedSubMenuTarget = flyoutContentSource;
    }
  }
}

function _hideSubMenuEntries (dialog) {
  $(dialog).find('.button-sub-menu').children().not('svg').addClass('closed');
}

export const DefaultOpenMenuEvents = 'pointerdown click';
